// extracted by mini-css-extract-plugin
module.exports = {"SigninPanelContent":"SigninPanel_SigninPanelContent__2AH-q","Error":"SigninPanel_Error__j-Tzi"};